import Repository from '../axios'
import {defaultPagination} from "../constants/config";

const resource = "/admin";

export default {
    getGlobalSearch(search) {
        return Repository.get(`${resource}/search?search=${search}`)
    },
};